/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{Version as s}from"../core/Version.js";class e extends s{constructor(s,e){super(s,e,"webmap")}}export{e as Version,e as default};
